// extracted by mini-css-extract-plugin
module.exports = {"blog-title-container":"TitleContainer_blog-title-container__SKHwD","blog-title":"TitleContainer_blog-title__22ZZx","bold":"TitleContainer_bold__3ZJLO"};